/**
 * @fileoverview Agent definition for key-events-expander-v2.
 *
 * Expands brief key events into detailed prose paragraphs based on
 * the chapter's projected word count.
 *
 * Rule of thumb: 2 paragraphs per 1000 words.
 *
 * @category narrative.chapters.planning
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'key-events-expander-v2',
  kind: 'primitive',
  name: 'Key Events Expander',
  description: 'Expands brief chapter key events into detailed prose paragraphs based on projected word count.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.chapters.planning',
    usedBy: [
      'primitives/use-key-events-expander-v2.ts',
    ],
    usedInComposites: [
      'chapter-planner-composite-v1',
    ],
    relatedAgents: [
      'chapter-planner-v2',
      'chapter-architect-v2',
    ],
  },
};
